import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { WAREHOUSE_TASK_LINE, WarehouseTaskLineStatusValues, WAREHOUSE_TASK_LINE_STATUS_LABELS, } from '../types/warehouse-task.js';
/**
 * Descriptor for WarehouseTaskLine — read via `/pg/v1`.
 * Mutated only by `/stock/tasks*` (request 0141 — phase 2 of spec 0036).
 */
export const warehouseTaskLineDescriptor = {
    name: WAREHOUSE_TASK_LINE,
    label: 'Linha de Tarefa de Armazém',
    domain: 'stock',
    collectionPath: 'org/{orgId}/warehouse-task-line',
    pathPatternKeys: { orgId: 'string' },
    version: 3,
    description: 'Elementary unit of work of a WarehouseTask',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'readonly',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'warehouseTaskId', label: 'Tarefa', type: 'string', required: true },
        { name: 'sequence', example: 1, label: 'Ordem', type: 'number', required: true },
        {
            name: 'targetKind',
            example: 'handling-unit',
            label: 'Tipo de alvo',
            type: 'enum',
            required: true,
            enumValues: ['handling-unit', 'stock-key', 'none'],
        },
        { name: 'handlingUnitId', label: 'Volume', type: 'string', required: false },
        { name: 'productId', label: 'Produto', type: 'string', required: false },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'lotId', label: 'Lote', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: false },
        { name: 'storageAddressId', label: 'Endereço', type: 'string', required: false },
        { name: 'expectedQuantity', example: 18.4, label: 'Quantidade esperada', type: 'number', display: 'quantity', required: false },
        { name: 'context', label: 'Contexto', type: 'object', required: false },
        {
            name: 'status',
            example: 'done',
            label: 'Status',
            type: 'enum',
            required: true,
            enumValues: [...WarehouseTaskLineStatusValues],
            enumLabels: WAREHOUSE_TASK_LINE_STATUS_LABELS,
            enumTones: {
                pending: 'neutral',
                'in-progress': 'info',
                done: 'success',
                skipped: 'warning',
                cancelled: 'destructive',
            },
        },
        {
            name: 'steps',
            label: 'Roteiro (snapshot)',
            type: 'object',
            required: false,
            description: 'Resolved roteiro at line creation (request 0147 §2.2) — never re-read from type',
        },
        {
            name: 'currentStepIndex',
            label: 'Passo atual',
            type: 'number',
            required: false,
        },
        {
            name: 'stepResults',
            label: 'Resultados dos passos',
            type: 'object',
            required: false,
            description: 'Parallel array to steps — { at, by, clientRequestId, output } per step run',
        },
        { name: 'completedAt', example: '2026-10-20', label: 'Conclusão', type: 'date', display: 'datetime', required: false },
        { name: 'createdAt', example: '2026-10-20', label: 'Criado em', type: 'date', display: 'datetime', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'warehouseTaskId',
            targetEntity: 'WarehouseTask',
            relationship: 'many-to-one',
            displayField: 'id',
        },
        {
            fieldName: 'handlingUnitId',
            targetEntity: 'HandlingUnit',
            relationship: 'many-to-one',
            displayField: 'code',
        },
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'storageAddressId',
            targetEntity: 'StorageAddress',
            relationship: 'many-to-one',
            displayField: 'code',
        },
    ],
};
//# sourceMappingURL=warehouse-task-line.descriptor.js.map